import { Grid } from "@mui/material";

type ScreenFooterProps = {
  children: React.ReactNode;
};

export function ScreenFooter({ children }: ScreenFooterProps) {
  return (
    <Grid
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
      item
      paddingBottom={{
        xs: "10px",
        sm: "20px",
      }}
      paddingLeft={{
        xs: "30px",
        sm: "40px",
      }}
      paddingRight={{
        xs: "30px",
        sm: "40px",
      }}
      xs={12}
    >
      {children}
    </Grid>
  );
}
